import { handleActions } from "redux-actions";
import { getInitialRangeOptions } from "../../constants";
import {
  SET_LOADING,
  SET_CONSTANTS,
  FETCH_MODULE,
  TOGGLE_VIEW,
  FETCH_FILTERS,
  UPDATE_FILTERS,
  NUM_OF_INTROS
} from "../sagas/marketing";
import { getSelectedRangeOptionWithCustom } from "../../../../utils/date-range-options";

export const initialState = {
  dataTable: {},
  initialRequest: false,
  options: {},
  listeners: [],
  isLoading: true,
  material: false,
  isTable: false,
  filters: {
    periodTypes: ["Daily", "Weekly", "Monthly", "Quarterly", "Yearly"],
    filtersDirty: false
  }
};

const getActionKey = (key) => key + "/" + NUM_OF_INTROS;

export default handleActions(
  {
    [getActionKey(SET_LOADING)]: (state, { payload }) => ({
      ...state,
      isLoading: payload
    }),
    [getActionKey(SET_CONSTANTS)]: (state, { payload }) => ({
      ...state,
      ...payload,
      initialRequest: true
    }),
    [getActionKey(TOGGLE_VIEW)]: (state, { payload }) => ({ ...state, isTable: payload }),
    [getActionKey(UPDATE_FILTERS)]: (state, { payload }) => ({
      ...state,
      filters: { ...state.filters, filtersDirty: true, ...payload }
    }),
    [getActionKey(FETCH_MODULE)]: (state, { payload: { data_table: dataTable, ...rest } }) => ({
      ...state,
      ...rest,
      filters: { ...state.filters, filtersDirty: false },
      isLoading: false,
      dataTable
    }),
    [getActionKey(FETCH_FILTERS)]: (
      state,
      { payload: { start_date: startDate, end_date: endDate, period_type: periodType, ...rest } }
    ) => {
      // fetch filters always reinitializes all filters with default values
      return {
        ...state,
        isTable: false,
        filters: {
          ...initialState.filters,
          ...rest,
          periodType,
          startDate,
          endDate,
          rangeValue: getSelectedRangeOptionWithCustom({ payload: { startDate, endDate } }), // set as current selected
          // get preexisting range options from getRangeOptions function + Custom Range
          rangeOptions: getInitialRangeOptions(startDate, endDate, state.theBeginningOfTime)
        }
      };
    }
  },
  initialState
);
